module.exports = __webpack_public_path__ + "img/banner-4.516ac0b5.jpg";